module.exports = __webpack_public_path__ + "img/logo-tl-mobil-light.e26ca969.svg";